import React from 'react';
import GenericMenu from './source/GenericMenuProject';
import { ANALYTIC_MENU, ANALYTIC_SECTION } from './constants/menuStructureProject';

export default function AnalyticMenu(props) {
  return (
    <GenericMenu 
      menuConfig={ANALYTIC_MENU} 
      sectionsMap={ANALYTIC_SECTION} 
      propsRouter={props} 
    />
  );
}